import { render, staticRenderFns } from "./person-message.vue?vue&type=template&id=6ec01c67&scoped=true&"
import script from "./person-message.vue?vue&type=script&lang=js&"
export * from "./person-message.vue?vue&type=script&lang=js&"
import style0 from "./person-message.vue?vue&type=style&index=0&id=6ec01c67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec01c67",
  null
  
)

export default component.exports